import { Inject, Component, ChangeDetectorRef } from "@angular/core";
import * as Immutable from "immutable";

import { ProductDataStore } from "../../../shared/providers/productData";
import { RouteRedirector } from "../../../shared/providers";
import { AutomaticUnlockMessage, ClearedParamInfo } from "../../../shared/models/responses/messages";
import { ConfigurationSessionManager, ConfiguratorStore, ConfPageSessionService, ConfRouteParams, PopupIdentifiers } from "../../providers";
import { BaseComponent } from "../../../shared";
import { AbstractPopupComponent } from "../../../../shared/components/popup/abstractPopupComponent";
import { ConfInfo } from "../../../shared/models";
import { PopupService } from "../../../../shared/components";
import { ImageSets } from "../../../../shared/utils";

@Component({
  selector: 'automatic-unlock-popup',
  templateUrl: './automaticUnlockPopupComponent.html'
})
export class AutomaticUnlockPopupComponent extends AbstractPopupComponent {
  public clearedValueModels: Array<AutomaticUnlockConfigurationModel>;

  public id = PopupIdentifiers.AutomaticUnlock;

  public imageSet: string;
  public contentImageSet: string;

  constructor(
    @Inject(ProductDataStore) public productStore: ProductDataStore,
    @Inject(ConfiguratorStore) public confStore: ConfiguratorStore,
    @Inject(ConfPageSessionService) public storeSession: ConfPageSessionService,
    @Inject(RouteRedirector) public routeRedirector: RouteRedirector,
    @Inject(PopupService) public popupService: PopupService,
    public cdr: ChangeDetectorRef
  ) {
    super(cdr, popupService);
  }

  ngOnInit() {
    this.imageSet = this.getImageSet(ImageSets.Popup);
    this.contentImageSet = this.getImageSet(ImageSets.Help);
    super.ngOnInit();
  }

  public open(tag: any) {
    this.show(tag);
  }

  show(messages: Immutable.List<AutomaticUnlockMessage>): void {
    this.clearedValueModels = [];

    // Setup a model for each message (aka for each configuration) with its automatic unlocks.
    messages.forEach(message => {
      let automaticUnlockModel = new AutomaticUnlockConfigurationModel();
      automaticUnlockModel.conf = this.confStore.getConfInfo(message.configurationId, this.storeSession.confSessionId);
      automaticUnlockModel.isActiveConf = this.storeSession.activeConfigurationId === message.configurationId;
      automaticUnlockModel.clearedParamInfos = message.clearedParamInfos.toArray();
      automaticUnlockModel.title = message.title;

      this.clearedValueModels.push(automaticUnlockModel);
    });

    this.showInternal();
  }

  public onAccordionOpen(configurationId: number) {
    // Accordion expand will route to the clicked configuration 
    this.routeRedirector.redirectToEditor(<ConfRouteParams>{ id: configurationId, confSessionId: this.storeSession.confSessionId })
  }

  public onPopupClosed() {
    this.clearedValueModels = null;
    super.onPopupClosed();
  }
}

export class AutomaticUnlockConfigurationModel {
  conf: ConfInfo;
  isActiveConf = false;
  title: string;
  clearedParamInfos: Array<ClearedParamInfo> = [];
}
